export const AFFIRMATIVE = 'AFFIRMATIVE';
export const NEGATIVE = 'NEGATIVE';
